import { Controller } from "stimulus"

export default class extends Controller {

  onDelete(event) {
    this.element.parentNode.remove()
  }
}
